import { render } from "./CotizacionView.vue?vue&type=template&id=457229bc"
import script from "./CotizacionView.vue?vue&type=script&lang=js"
export * from "./CotizacionView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__